module.exports = __webpack_public_path__ + "mainassets/img/arrow-right.5d304800.svg";